(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pulse-massage-cycle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pulse-massage-cycle')) {
  class PulseMassageCycle extends HTMLElement {
    static framesForMode(mode) {
      const frames = [];
      const cumulative = (count) => Array.from({ length: count }, (_, index) => index + 1);
      const add = (zones, phase, duration, extra = {}) => frames.push({ zones, phase, duration, ...extra });
      if (mode === 1 || mode === 2) {
        for (let chamber = 1; chamber <= 5; chamber++) add(cumulative(chamber), 'inflate', 1100);
        add(cumulative(5), 'hold', mode === 1 ? 3000 : 8000);
        add([], 'release', 800);
      } else if (mode === 3) {
        for (let chamber = 1; chamber <= 5; chamber++) {
          const previous = chamber > 1 ? [chamber - 1] : [];
          for (let pulse = 1; pulse <= 3; pulse++) {
            add([...previous, chamber], 'inflate', 700, { chamber, pulse, pulseTotal: 3 });
            if (pulse < 3) add([...previous], 'pulseRelease', 450, { chamber, pulse, pulseTotal: 3 });
          }
        }
        add([], 'release', 800);
      } else if (mode === 4) {
        for (let chain = 1; chain <= 5; chain++) {
          for (let repetition = 1; repetition <= 2; repetition++) {
            for (let chamber = 1; chamber <= chain; chamber++) {
              add(cumulative(chamber), 'inflate', 1100, { chain, repetition, repetitionTotal: 2 });
            }
            add([], 'release', 650, { chain, repetition, repetitionTotal: 2 });
          }
        }
      } else {
        for (let chamber = 1; chamber <= 5; chamber++) add([chamber], 'inflate', 1100);
        add([], 'release', 800);
      }
      return frames;
    }

    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.frames = PulseMassageCycle.framesForMode(Number(this.dataset.mode));
      this.index = 0;
      this.playing = false;
      this.timer = null;
      this.playButton = this.querySelector('[data-cycle-play]');
      this.playLabel = this.querySelector('[data-cycle-play-label]');
      this.playIcon = this.querySelector('[data-cycle-play-icon]');
      this.phaseLabel = this.querySelector('[data-cycle-phase]');
      this.stepLabel = this.querySelector('[data-cycle-step]');
      this.activeLabel = this.querySelector('[data-cycle-active]');
      this.announcement = this.querySelector('[data-cycle-announcement]');
      this.zoneNodes = Array.from(this.querySelectorAll('[data-zone]'));
      this.legendNodes = Array.from(this.querySelectorAll('[data-zone-label]'));
      this.ancestors = [];
      for (let node = this.parentElement; node; node = node.parentElement) {
        if (node.tagName === 'DETAILS') {
          this.ancestors.push(node);
          node.addEventListener('toggle', () => {
            if (!node.open) this.pause();
          }, { signal });
        }
      }
      this.playButton.addEventListener('click', () => {
        if (this.playing) this.pause();
        else this.play();
      }, { signal });
      this.querySelector('[data-cycle-next]').addEventListener('click', () => {
        this.pause();
        this.advance(true);
      }, { signal });
      this.querySelector('[data-cycle-reset]').addEventListener('click', () => {
        this.pause();
        this.index = 0;
        this.render(true);
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
      }, { signal });
      this.render();
      this.updatePlayback();
    }

    disconnectedCallback() {
      this.pause();
      this.controller?.abort();
      this.controller = null;
    }

    play() {
      if (!this.isConnected || document.hidden || this.ancestors.some((node) => !node.open)) return;
      this.playing = true;
      this.updatePlayback();
      this.schedule();
    }

    pause() {
      clearTimeout(this.timer);
      this.timer = null;
      this.playing = false;
      if (this.playButton) this.updatePlayback();
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (!this.playing || !this.isConnected || document.hidden || this.ancestors.some((node) => !node.open)) {
          this.pause();
          return;
        }
        this.advance();
        this.schedule();
      }, this.frames[this.index].duration);
    }

    advance(announce = false) {
      this.index = (this.index + 1) % this.frames.length;
      this.render(announce);
    }

    updatePlayback() {
      this.dataset.playing = String(this.playing);
      this.playButton.setAttribute('aria-pressed', String(this.playing));
      this.playLabel.textContent = this.playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.playIcon.textContent = this.playing ? 'Ⅱ' : '▶';
    }

    render(announce = false) {
      const frame = this.frames[this.index];
      const active = new Set(frame.zones);
      this.zoneNodes.forEach((node) => node.classList.toggle('is-active', active.has(Number(node.dataset.zone))));
      this.legendNodes.forEach((node) => node.classList.toggle('is-active', active.has(Number(node.dataset.zoneLabel))));
      let phase = this.dataset[`${frame.phase}Label`];
      if (frame.phase === 'hold') phase += ` · ${frame.duration / 1000} s`;
      if (frame.pulse) phase += ` · ${this.dataset.pulseLabel} ${frame.pulse}/${frame.pulseTotal}`;
      if (frame.repetition) phase += ` · ${this.dataset.repetitionLabel} ${frame.repetition}/${frame.repetitionTotal}`;
      this.phaseLabel.textContent = phase;
      this.stepLabel.textContent = `${this.dataset.stepLabel} ${this.index + 1} ${this.dataset.ofLabel} ${this.frames.length}`;
      this.activeLabel.textContent = `${this.dataset.activeLabel} : ${frame.zones.length ? frame.zones.join(' + ') : this.dataset.noneLabel}`;
      this.dataset.frame = String(this.index);
      this.dataset.phase = frame.phase;
      this.dataset.activeZones = frame.zones.join(',');
      if (announce) this.announcement.textContent = `${this.phaseLabel.textContent}. ${this.activeLabel.textContent}. ${this.stepLabel.textContent}.`;
    }
  }
  customElements.define('pulse-massage-cycle', PulseMassageCycle);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pulse-rail-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pulse-rail')) {
  customElements.define('pulse-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('[data-rail-track]');
      this.cards = [...this.track.children];
      this.addEventListener('click', event => {
        if (event.target.closest('[data-rail-next]')) this.move(1);
        if (event.target.closest('[data-rail-prev]')) this.move(-1);
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        if (event.target !== this.track) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.querySelector('.pulse-rail__controls').hidden = max <= 2;
      this.track.tabIndex = max > 2 ? 0 : -1;
      const bounds = this.track.getBoundingClientRect();
      this.index = this.cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - bounds.left) < Math.abs(this.cards[best].getBoundingClientRect().left - bounds.left) ? index : best, 0);
      if (max > 2 && this.track.scrollLeft >= max - 2) this.index = this.cards.length - 1;
      this.querySelector('[data-rail-prev]').disabled = this.track.scrollLeft <= 2;
      this.querySelector('[data-rail-next]').disabled = max <= 2 || this.track.scrollLeft >= max - 2;
      this.querySelector('[data-rail-current]').textContent = String(this.index + 1).padStart(2, '0');
    }
    move(direction) {
      const distance = this.cards.length > 1 ? this.cards[1].getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left : this.track.clientWidth;
      const left = Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, this.track.scrollLeft + direction * distance));
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
